import { VisibilityState } from '@tanstack/vue-table'

import { PatientType, ClinicType, DataType, ProcedureType } from '@/types'

export enum LeadTypeEnum {
  CALL = 'call',
  INQUIRY = 'inquiry',
  REVIEW = 'review',
  QUESTION = 'question',
  SURVEY = 'survey',
  SCHEDULED_EVENT = 'scheduled event',
  SMS_INQUIRY = 'sms inquiry',
  CHAT = 'chat',
  CONVERSIOBOT = 'conversiobot',
  ORDER = 'order',
  OFFER = 'offer',
  GOOGLE_LEAD = 'google lead',
  INSTANT_QUOTE = 'instant quote',
}

export enum LeadStatusEnum {
  PENDING = 'pending',
  OPENED = 'opened',
  SENT_UNOPENED = 'sent - unopened',
  ERROR = 'error',
  FILTERED = 'filtered',
  CREATED = 'created',
  SPAM = 'spam',
  CALL_INBOUND = 'call-inbound',
  ORDER_COMPLETE = 'order-complete',
  ORDER_PAID = 'order-paid',
  TEST = 'test',
}

export type LeadGeoType = {
  city: string
  country: string
  countryCode: string
  latitude: number
  longitude: number
  region: string
  regionCode: string
  continent: string
  continentCode: string
  timezone: string
  postalCode: string
}

export type LeadFieldItemType = {
  productId: string
  name: string
  description: string
  link: string | null
  quantity: number
  total: number
}

export type LeadFieldSurveyType = {
  survey?: {
    stepNumber: number
    question: string
    answers?: string[]
  }[]
}

export type LeadFieldQuestionAnswerType = {
  answer: string
  position: number
  question: string
}

export type LeadFieldPaymentType = {
  amount: number
  currency: string
  external_id: string | null
  provider: string
  successful: boolean
  terms: string
}

export type LeadFieldScheduledEventType = {
  start_time: string
  end_time: string
  name: string
  location: {
    location?: string
    type?: string
  }
}

export type LeadFieldCancellationType = {
  created_at: string
  canceled_by?: string
  canceler_type?: string
  reason?: string
}

export type LeadFieldConversationalTranscriptType = {
  speaker: string
  phrase: string
  start: number
}

export type LeadFieldType = Record<string, DataType | DataType[]> & {
  items?: LeadFieldItemType[]
  user_column_data?: object
  data?: LeadFieldSurveyType
  billing?: object
  shipping?: object
  questions_and_answers?: LeadFieldQuestionAnswerType[]
  payment?: LeadFieldPaymentType
  scheduled_event?: LeadFieldScheduledEventType
  cancellation?: LeadFieldCancellationType
  conversational_transcript?: LeadFieldConversationalTranscriptType[]
}

export type LeadType = {
  id: string
  type: LeadTypeEnum
  status: LeadStatusEnum
  name: string
  email: string
  phone: string
  message: string
  source: string
  geo?: LeadGeoType
  fields?: LeadFieldType
  customer_services?: ProcedureType[]
  created_at: string
  updated_at: string
  deleted_at: string
  client?: PatientType
  website?: ClinicType
}

export type LeadFilterType = {
  search?: string
  archived?: string
  selectedWebsites: string[]
  selectedStatuses: LeadStatusEnum[]
  selectedTypes: LeadTypeEnum[]
  columnVisibility?: VisibilityState
  columnOrder: string[]
}
